import { AppTheme } from '../../../../../main-service/infrastructure/types/features/themes/theme-types';

const colors = {
  primaryColor: 'red' as Color,
};

const otherTheme: AppTheme = {
  id: 'other',
  colors: colors,
  font: 'SkorozvonRoboto' as Font,
  components: {
    menu: {
      primary: {
        itemColor: 'red' as Color,
      },
    },
    tabs: {
      primary: {
        brandColor: 'red' as Color,
      },
    },
  },
};

export default otherTheme;
